/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerskindlabel2Inputs */

const en_partnerskindlabel2 = /** @type {(inputs: Partnerskindlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kind`)
};

const de_partnerskindlabel2 = /** @type {(inputs: Partnerskindlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art`)
};

/**
* | output |
* | --- |
* | "Kind" |
*
* @param {Partnerskindlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerskindlabel2 = /** @type {((inputs?: Partnerskindlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerskindlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerskindlabel2(inputs)
	return de_partnerskindlabel2(inputs)
});
export { partnerskindlabel2 as "partnersKindLabel" }